'use client';

import { MessageCircle } from 'lucide-react';
import { useTranslations } from 'next-intl';

export const ChatEmptySession = () => {
  const t = useTranslations('claw.chat.emptySession');

  return (
    <div className="flex h-full min-h-[260px] items-center justify-center px-6">
      <div className="flex max-w-[360px] flex-col items-center text-center">
        <div className="mb-4 flex size-12 items-center justify-center rounded-full bg-system-white08 light:bg-[rgba(87,101,242,0.12)]">
          <MessageCircle className="size-5 light:text-[#5765F2] text-system-white36" />
        </div>
        <p className="font-medium light:text-system-text02 text-sm text-system-white80">{t('title')}</p>
        <p className="mt-2 light:text-system-text04 text-sm text-system-white40 leading-6">{t('description')}</p>
      </div>
    </div>
  );
};
